export const AuthenticationEn = {
  lang: 'en',
  data: {
    AUTHENTICATION: {
      LEFT_CONTENT: {
        TITLE1: 'Predictive Analytics Driven   ',
        TITLE2: 'Pentest Platform',
        SUB_TITLE: 'Artemis is a pentest platform that helps you protect against Cyber Threats using data driven analytics. ',
      },
      ACTION: {
        FIRST_TIME_USER: 'First time user?',
        GET_STARTED_NOW: 'Get Started Now',
        VERIFICATION_LINK_EXPIRED: 'Verification link expired?',
        RESEND_VERIFICATION_LINK: 'Resend Verification Link',
        SIGN_IN: 'Sign In',
        RESET_PASSWORD: 'RESET PASSWORD',
        VERIFY_YOUR_DETAILS: 'Verify your details',
        SUBMIT: 'Submit',
        SEND: 'SEND',
      },
      COMMON: {
        EMAIL: 'Email',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        GOOGLE_PRIVACY_POLICY: 'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.',
        TOKEN_EXPIRED: 'Token Expired!',
        TOKEN_INVALID: 'Token Invalid!',
        TOKEN_INVALID_MESSAGE1: 'Sorry, There was some error while verifying account.',
        TOKEN_INVALID_MESSAGE2: 'Please contact the support team.',
        TOKEN_EXPIRED_MESSAGE: 'Sorry, Your token may have expired.',
        VALIDATING_TOKEN_MESSAGE: 'Please wait while we validate the token...!',
        POLICY_TEXT: {
          TEXT1: 'By continuing, you agree to the ',
          TEXT2: 'Terms of Use',
          TEXT3: ', ',
          TEXT4: 'Privacy Policy',
          TEXT5: ' and ',
          TEXT6: 'Security Policy',
          TEXT7: ' of Hive Pro Inc.',
        },
        SHOW_PASSWORD: 'Show Password',
        HIDE_PASSWORD: 'Hide Password',
        SHOW_OTP: 'Show OTP',
        HIDE_OTP: 'Hide OTP',
      },
      ACCOUNT_REGISTER: {},
      LOGIN: {
        FORGOT_PASSWORD: 'Forgot Password?',
        PASSWORD_EXPIRED: 'Password Expired?',
        SIGNIN: 'Sign In',
        TWO_STEP_VERIFICATION: 'Two-step Verification',
        DIGIT_CODE: '4-digit code send to',
        GENERATED_CODE: 'Please enter your google authenticator generated code',
        ENTER_OTP: 'Enter OTP',
        SUBMIT: 'Submit',
        VERIFICATION_PENDING: 'Verification Pending',
        BACK_TO_SIGN_IN: 'Back to Sign In',
        PLEASE_VERIFY: ' Please verify your',
        AND: 'and',
        MOBILE_NUMBER: 'Mobile Number',
        OTP: 'OTP',
        SCAN_BELOW_BARCODE: 'Scan below barcode using google authenticator application, enter OTP and click submit',
        REMEMBER_MFA: 'Remember 2FA',
        SIGN_UP_AS: 'Sign Up as',
        GET_STARTED_AS: 'Get Started as',
        CUSTOMER: 'Customer',
        PENTESTER: 'Pentester',
        ENTER_RECEIVED_OTP: 'Enter received OTP',
      },
      VERIFY_UPDATED_EMAIL: {
        WELCOME_TEXT: 'Welcome to ',
        SUCCESS_TEXT1: 'Congratulations, You have successfully verified your email. ',
        SUCCESS_TEXT2: 'Click on the button below to sign in with your credentials.',
      },
      UNBLOCK_GENERATE_PASSWORD: {
        TITLE: 'Reset Password',
        WELCOME_TEXT: 'Welcome to ',
        SUCCESS_TEXT1: 'Congratulations your account is unblocked. ',
        SUCCESS_TEXT2: 'Click on the button below to sign in with your credentials.',
        PLACEHOLDER: {
          REENTER_NEW_PASSWORD: 'Re-enter new password',
          ENTER_NEW_PASSWORD: 'Enter new password',
        },
        VALIDATION: {
          MISTMATCH_ERROR: 'Password and Confirm Password does not match',
        },
      },
      RESET_PASSWORD: {
        TITLE: 'Reset Password',
        NEW_PASSWORD: 'New Password',
        CONFIRM_NEW_PASSWORD: 'Confirm New Password',
        WELCOME_TEXT: 'Welcome to ',
        SUCCESS_TEXT1: 'Congratulations your password is reset now! ',
        SUCCESS_TEXT2: 'Click on the button below to sign in with your credentials. ',
        VALIDATION: {
          MISTMATCH_ERROR: 'Password and Confirm Password does not match',
        },
        PLACEHOLDER: {
          REENTER_NEW_PASSWORD: 'Re-enter new password',
          ENTER_NEW_PASSWORD: 'Enter new password',
        },
        GENERATE_PASSWORD: {
          TITLE: 'Generate Password',
          NEW_PASSWORD: 'New Password',
          CONFIRM_NEW_PASSWORD: 'Confirm New Password',
          WELCOME_TEXT: 'Welcome to ',
          SUCCESS_TEXT1: 'Congratulations on setting up your account!',
          SUCCESS_TEXT2: 'Click on the button below to sign in with your credentials. ',
          SUCCESS_TEXT3: 'We are glad to have you on board!',
          VALIDATION: {
            MISTMATCH_ERROR: 'Password and Confirm Password does not match',
          },
          PLACEHOLDER: {
            REENTER_NEW_PASSWORD: 'Re-enter new password',
            ENTER_NEW_PASSWORD: 'Enter new password',
          },
        },
      },
      ACCOUNT_VERIFIED: {
        WELCOME_TEXT: 'Welcome to ',
        SUCCESS_TEXT1: 'Congratulations on setting up your account!',
        SUCCESS_TEXT2: 'Click on the button below to sign in with your credentials. ',
        SUCCESS_TEXT3: 'We are glad to have you on board!',
      },
      RESEND_VERIFICATION_LINK: {
        EMAIL_SENT: 'An email has been sent to your',
        REGISTERED_EMAIL: 'registered email',
        FINISH_REGISTRATION_PROCESS: 'Click on \'Verify my account\' link in the email to complete registration process.',
      },
    },
  },
};
